/* spellchecker: disable */
export const outcomeLabels = [
	{
		color: "0075ca",
		description: "Improvements or additions to docs",
		name: "area: documentation",
	},
	{
		color: "6009D7",
		description:
			"Improving how the repository's tests are run and/or code is tested",
		name: "area: testing",
	},
	{
		color: "f9d0c4",
		description: "Managing the repository's maintenance",
		name: "area: tooling",
	},
	{
		color: "5319E7",
		description: "Good for newcomers, please hop on!",
		name: "good first issue",
	},
	{
		color: "7a5901",
		description: "This doesn't seem right",
		name: "invalid",
	},
	{
		color: "0E8A16",
		description: "Please, send a pull request to resolve this!",
		name: "status: accepting prs",
	},
	{
		color: "#ddcccc",
		description: "Waiting for something else to be resolved",
		name: "status: blocked",
	},
	{
		color: "cfd3d7",
		description: "This issue or pull request already exists",
		name: "status: duplicate",
	},
	{
		color: "#05104F",
		description: "Not yet ready for implementation or a pull request",
		name: "status: in discussion",
	},
	{
		color: "D3F82D",
		description: "Further research required...?",
		name: "status: needs investigation",
	},
	{
		color: "E4BC82",
		description: "Needs an action taken by the original poster",
		name: "status: waiting for author",
	},
	{
		color: "ffffff",
		description: "This will not be worked on",
		name: "status: wontfix",
	},
	{
		color: "d73a4a",
		description: "Something isn't working :(",
		name: "type: bug",
	},
	{
		color: "a2eeef",
		description: "New enhancement or request",
		name: "type: feature",
	},
	{
		color: "d876e3",
		description: "Further information is requested",
		name: "type: question",
	},
	{
		color: "fde282",
		description: "Tech debt or other code/repository cleanups",
		name: "type: cleanup",
	},
];
